var React = require('react');

function Carryout (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M828.25,354.17h-118.5c-.05-3.8-.1-7.59-.16-11.35-.41-25.69-1.17-73.52-22-114.17-17.67-34.48-55.95-75.49-137.93-76.4v-.04c-.47,0-.92.02-1.38.02-.47,0-.91-.02-1.38-.02v.04c-81.98.91-120.26,41.92-137.93,76.4-20.83,40.65-21.59,88.47-22,114.17-.06,3.76-.11,7.55-.16,11.35h-135.06l-41.6,512.14h659.7l-41.6-512.14ZM457.23,343.93c.34-21.38.91-57.15,14.27-83.24,8.33-16.26,25.37-37.82,76.78-38.21,51.41.39,68.45,21.94,76.78,38.21,13.37,26.08,13.93,61.86,14.27,83.24.05,3.39.1,6.81.14,10.24h-182.39c.04-3.43.09-6.84.14-10.24ZM753.61,761.46h-427.22v-40.14h427.22v40.14Z"}));
}

Carryout.defaultProps = {"id":"ICONS","viewBox":"0 0 1080 1080"};

module.exports = Carryout;

Carryout.default = Carryout;
